import { Col, Form, Select } from "antd";
import { SALES_CONTRACT_COMMERCIAL_LIST } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { useCallback, useEffect, useState } from "react";

const LienCostFilterFields = ({ initialTableData }) => {
  const { Option } = Select;
  const [salesContracts, setSalesContracts] = useState([]);
  const [loading, setLoading] = useState(false);

  const getSalesContractNumber = async (filter) => {
    setLoading(true);
    const body = {
      page: 1,
      per_page: 10,
      ...(filter?.reference_no && { reference_no: filter.reference_no }),
    };
    const response = await getData(
      `${SALES_CONTRACT_COMMERCIAL_LIST}`,
      null,
      body,
    );
    if (response?.status === 200) {
      setSalesContracts(response?.data?.data?.data || []);
    }
    setLoading(false);
  };

  // on search sales contracts
  const onSalesContractSearch = useCallback(async (value) => {
    if (value && value.length >= 2) {
      await getSalesContractNumber({ reference_no: value });
    } else if (!value) {
      await getSalesContractNumber();
    }
  }, []);

  useEffect(() => {
    getSalesContractNumber();
  }, []);

  return (
    <>
      <Col span={4}>
        <Form.Item label="Sales Contract No." name="sales_contract_id">
          <Select
            size="small"
            placeholder="Select Sales Contract No."
            loading={loading}
            showSearch
            optionFilterProp="children"
            onSearch={onSalesContractSearch}
            allowClear
          >
            {salesContracts.map((contract) => (
              <Option
                key={contract.sales_contract_id}
                value={contract.sales_contract_id}
              >
                {contract.sale_contract_info?.reference_no}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default LienCostFilterFields;
